import { Squares2X2Icon } from '@heroicons/react/24/outline';
import { useAppSelector } from 'app/hooks';
import GridDraggableItem from 'components/structure-page/2d/grid-draggable-item';

type CondenserListProps = {
  disabled?: boolean;
};

export default function CondenserList({
  disabled: disabledProp = false
}: CondenserListProps) {
  const { estimatingStructure, activeLevelIndex } = useAppSelector(
    (state) => state.ui
  );
  const { structure } = useAppSelector((state) => state.structure);

  const activeLevel = structure[activeLevelIndex];
  const isBasementOrCrawlspace =
    activeLevel?.type === 'basement' || activeLevel?.type === 'crawlspace';

  const disabled =
    disabledProp || estimatingStructure || isBasementOrCrawlspace;

  return (
    <div className='flex flex-col gap-3'>
      <div className='flex items-center gap-1'>
        <Squares2X2Icon className='h-6 w-6' />
        <span className='text-lg font-semibold'>Condensers</span>
      </div>
      <div className='flex flex-col gap-2'>
        <GridDraggableItem
          id='new-condenser'
          label='Condenser'
          type='new-condenser'
          disabled={disabled}
          color='purple'
          image='/images/condensers/condenser-on-ground.jpeg'
          description='Drag onto the layout to place'
          size='large'
        />
      </div>
    </div>
  );
}
